import { FC } from 'react'

import InteractiveGameDisplay from '@/components/InteractiveGameDisplay'

const Images: FC<{ activeImageNumber: string; isMobile?: boolean }> = ({
    activeImageNumber,
    isMobile,
}) => {
    const items = isMobile
        ? ['1', '2', '3']
        : ['11', '12', '13', '21', '22', '23', '31', '32', '33']

    return (
        <>
            {items.map((currentImageNumber, index) => (
                <InteractiveGameDisplay
                    key={`interactive-map-bg-${index}`}
                    backgroundImageProperty={`/images/ets-maps/ets-explorer-${
                        isMobile ? 'mobile' : 'desktop'
                    }-${currentImageNumber}.png`}
                    isActive={currentImageNumber === activeImageNumber}
                />
            ))}
        </>
    )
}

export default Images
